import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { User } from "../Model/User";

export async function patchUser(userId, data) {
	let response = await getAPIResponse("/v1/user/"+userId, data, "PATCH");
	if (response === null) {
		return null;
	}
	let user = User.createFromResponseData(response);
	return user;
}